<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { IncludedDeviation } from '@/types/delivery-management'
import { image } from '@/utils/assets'
import { emitter } from '@/utils/mitt'

import MyButton from '@/components/my-components/MyButton.vue'

interface Props {
    deviations: IncludedDeviation[]
}

defineProps<Props>()

const { t } = useI18n()
</script>
<template>
    <div
        class="flex flex-col gap-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-dark-400 p-3 w-1/3"
    >
        <div v-for="(deviation, index) in deviations" :key="deviation.id" class="w-full">
            <div class="flex justify-between">
                <MyButton
                    scheme="primary"
                    plain
                    icon
                    size="small"
                    @click="emitter.emit('openDeviationModal', deviation.id)"
                >
                    <mdi:eye class="ml-0.5" />
                </MyButton>

                <div class="w-1/2">
                    <div class="text-sm font-semibold text-black dark:text-white">
                        {{ t('deviation') }}
                        <span v-if="deviation.number" class="ml-1 text-gray-500 dark:text-gray-400">
                            {{ deviation.number }}
                        </span>
                    </div>

                    <div class="mt-1 font-bold text-primary-500 dark:text-primary-200">
                        {{ deviation.tags.map((tag) => t(tag.name)).join(',') }}
                    </div>

                    <div class="mt-1 text-xs text-gray-700 dark:text-gray-300">
                        {{ deviation.note ?? '—' }}
                    </div>
                </div>

                <div
                    class="w-28 shrink-0 aspect-square overflow-hidden rounded-md bg-gray-100 bg-cover"
                    :style="{
                        'background-image': deviation.image
                            ? `url(${image(deviation.image)})`
                            : 'none',
                    }"
                />
            </div>
            <hr
                v-if="deviations.length > 1 && index !== deviations.length - 1"
                class="w-full h-[1px] border-primary-300 mt-2"
            />
        </div>
    </div>
</template>
